import script from "./SuccessCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessCard.vue?vue&type=script&setup=true&lang=js"

import "./SuccessCard.vue?vue&type=style&index=0&id=b4474418&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4474418"]])

export default __exports__